const baseFitmentFields = ['Year', 'Model', 'Submodel'];
const extraFitmentFields = ['Engine', 'BodyType', 'Sasquatch'];

const categorySelectionPageUrl = '/collections';

export default {
  platform: 'shopify',
  SearchRequestDefaults: {
    pageSize: 36,
  },
  product: {
    searchResultsImageWidth: 380,
    searchResultsImageHeight: 380,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [{ pathname: categorySelectionPageUrl, field: 'category' }],
    categorySelectionPageRedirect: true,
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '#cm_category-page-results',
      template: 'SearchPage',
    },
    {
      name: 'FacetPanel',
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Best Match',
        'title': 'Name, A-Z',
        'title:desc': 'Name, Z-A',
        'collection_sort': 'Featured',
        'price': 'Price, Low To High',
        'price:desc': 'Price, High To Low',
        'published_at': 'Date, Old To New',
        'published_at:desc': 'Date, New To Old',
      },
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchBox',
      location: { replace: '.popup-navigation__search .container > form', class: 'd-none d-lg-block' },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '#cm-search-box-mobile',
        class: 'ml-15',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'Garage',
      location: { insertAfter: '.header__line-top .custom-compare', class: 'ml-15' },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_categories-page',
      template: 'facetTiles/hierarchicalContainer',
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        lastChildOf: '#header .header__content',
        class: 'cm_vehicle-widget__header-container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      fields: baseFitmentFields,
      columnBreakpoint: 800,
      initCollapsed: true,
    },
    {
      name: 'VehicleSpecs',
      type: 'VehicleWidget',
      fields: extraFitmentFields,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: '.fitment-tab-title',
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FitmentTable',
      location: '.fitment-tab-body',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialogVehicleSpecs',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
